import type { CSSObject } from '@emotion/react'
import {
  Color,
  FocusIndicator,
  FontWeight,
  Spacing,
  Typography,
} from '@opallabs/gem'
import type { StyleProps } from './types'

export const container = ({ theme }: StyleProps): CSSObject => ({
  // This currently handles the dark theme explicitly because the `Gray`
  // `Text` color doesn't have enough contrast against the current
  // moment-shroud sidebar background.
  color: theme === 'dark' ? '#A0AEB9' : Color[theme].Text.Gray,
  ...Typography.T500,
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginBlockEnd: Spacing.S,

  '@media (prefers-contrast: more)': {
    color: Color[theme].Text.Default,
  },
})

export const infoIcon = ({ theme }: StyleProps): CSSObject => ({
  borderRadius: '50%',
  marginInlineStart: Spacing.S,

  '&:focus': {
    ...FocusIndicator[theme],
  },
})

export const infoPopoverContent = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Gray,
  ...Typography.T300,
  textAlign: 'start',
  textTransform: 'none',

  'dd + dt': {
    marginBlockStart: Spacing.S,
  },

  '@media (prefers-contrast: more)': {
    color: Color[theme].Text.Default,
  },
})

export const infoPopoverLabel = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Default,
})

export const infoPopoverText: CSSObject = {
  marginInlineStart: 0,
}

export const max: CSSObject = {
  ...Typography.M500,
  display: 'flex',
  fontSize: Typography.T300.fontSize,
  marginInlineStart: Spacing.S * 1.5,
}

export const title: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  ...Typography.T500,
  fontWeight: FontWeight.Semibold,
}
